// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3UcXk","selected":"Chip_selected__2c5cQ"};